import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Layout from "../../components/Layout.js";
import axios from "axios";
import Select from "react-select";
import { apiFetch } from "../../api.js";

const CreditcardMasterDetailsDesign = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const allowAlphabets = (value) => value.replace(/[^a-zA-Z ]/g, "");
  const allowAlphaNumeric = (value) => value.replace(/[^a-zA-Z0-9 ]/g, "");
  const allowNumbers = (value) => value.replace(/[^0-9]/g, "");
  const [entryDate, setEntryDate] = useState("");
  const [Cardname, setCardname] = useState("");
  const [Cardno, setCardno] = useState("");
  const [Accountname, setAccountname] = useState("");
  const [Abbreviation, setAbbreviation] = useState("");
  const [isEditMode, setIsEditMode] = useState(false);
  const [recordId, setRecordId] = useState(null);
  const [Accountnamelist, setAccountnamelist] = useState([]);
  const [ipAddress, setIpAddress] = useState("");
  const [userId, setUserId] = useState("");
  const [serverIp] = useState(window.location.hostname);
  const storedUserInfo = JSON.parse(sessionStorage.getItem("userinfo")) || {};

  function formatDateForInput(dateStr) {
    if (!dateStr) return "";
    const [day, month, year] = dateStr.split("-");
    return `${year}-${month}-${day}`;
  }
  const accountNameOptions = Accountnamelist.map((a) => ({
    value: a.value,
    label: a.value,
  }));

  const handleExit = () => {
    navigate("/Creditcard/grid");
  };

  useEffect(() => {
    axios
      .get("/api/get-ip")
      .then((res) => setIpAddress(res.data.ip))
      .catch(() => setIpAddress("0.0.0.0"));
  }, []);

  useEffect(() => {
    const storedUserInfo = JSON.parse(sessionStorage.getItem("userinfo")) || {};
    setUserId(storedUserInfo.userId || "");
  }, []);
  const handleSave = async () => {
    try {
      const payload = {
        entryDate,
        userId,
        ipAddress,
        serverIp,
        Cardname,
        Cardno,
        Accountname,
        Abbreviation,
      };

      const res = await apiFetch(
        "/api/creditcardmaster/insert",
        {
          method: "POST",
          body: JSON.stringify(payload),
        },
      );

      if (!res.ok) {
        const err = await res.text();
        console.error("SAVE ERROR:", err);
        alert("Save failed!");
        return;
      }

      const data = await res.json();
      console.log("Insert response:", data);

      if (data.success && data.status?.includes("successfully")) {
        alert("Saved successfully!");
        setEntryDate("");
        setCardname("");
        setCardno("");
        setAccountname("");
        setAbbreviation("");
        navigate("/creditcard/grid");
      } else {
        alert(data.status || "Error saving record");
      }
    } catch (err) {
      console.error("Insert error:", err);
      alert("Failed to save. Check console for details.");
    }
  };
  const handleUpdate = async () => {
    if (!recordId) {
      alert("No record selected for update.");
      return;
    }

    try {
      const payload = {
        entryDate,
        Cardname,
        Cardno,
        Accountname,
        Abbreviation,
      };

      const res = await apiFetch(
        `/api/creditcardmaster/update/${recordId}`,
        {
          method: "PUT",
          body: JSON.stringify(payload),
        },
      );

      if (!res.ok) {
        const errorText = await res.text();
        console.error("Update failed:", errorText);
        alert(`Update failed (${res.status}). Check console for details.`);
        return;
      }

      const data = await res.json();
      console.log("Update response:", data);

      if (data?.status?.toLowerCase().includes("success")) {
        alert("Updated successfully!");
        navigate("/creditcard/grid");
      } else {
        alert(data?.error || data?.message || "Update failed.");
      }
    } catch (err) {
      console.error("Update error:", err);
      alert("Failed to update. Check console for details.");
    }
  };

  useEffect(() => {
    const fetchDropdowns = async () => {
      try {
        const res = await apiFetch(
          "/api/Creditcardmaster/accountnames",
          {
            method: "GET",
          },
        );

        if (!res.ok) {
          const err = await res.text();
          console.error("DROPDOWN ERROR:", err);
          return;
        }

        const accData = await res.json();
        console.log("Fetched accounts:", accData);

        if (Array.isArray(accData)) setAccountnamelist(accData);
      } catch (err) {
        console.error("❌ Error fetching dropdowns:", err);
      }
    };

    fetchDropdowns();
  }, []);

  useEffect(() => {
    const editData = location.state?.editData;

    if (editData && typeof editData === "object") {
      const {
        entrydate = "",
        cardname = "",
        cardno = "",
        acname = "",
        abbreviation = "",
        sp_492,
        uniqueid,
      } = editData;

      setEntryDate(entrydate);
      setCardname(cardname);
      setCardno(cardno);
      setAccountname(acname);
      setAbbreviation(abbreviation);
      setRecordId(sp_492 || uniqueid || null);
      setIsEditMode(true);
    } else {
      setIsEditMode(false);
      setEntryDate("");
      setCardname("");
      setCardno("");
      setAccountname("");
      setAbbreviation("");
      setRecordId(null);
    }
  }, [location.state]);

  /*------------------- Styles--------------*/
  /*------------------- Styles--------------*/

  const pageContainerStyle = {
    width: "100%",
    minHeight: "100vh",
    backgroundColor: "#f4f6f8",
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start",
    padding: "10px",
    boxSizing: "border-box",
  };

  const containerStyle = {
    width: "100%",
    maxWidth: "1200px",
    padding: "16px",
    borderRadius: "8px",
    backgroundColor: "#fff",
    boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
    boxSizing: "border-box",
  };

  const headerStyle = {
    border: "2px solid #8B1E3F",
    borderRadius: "6px",
    padding: "15px",
    marginBottom: "20px",
    textAlign: "center",
    background: "#8B1E3F",
    fontWeight: "bold",
    fontSize: "1.5rem",
    color: "#fff",
  };

  const rowStyle = {
    display: "grid",
    width: "100%",
    gap: "16px",
    marginBottom: "16px",
    gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
  };

  const columnStyle = {
    display: "flex",
    flexDirection: "column",
  };

  const inputStyle = {
    padding: "10px",
    marginTop: "5px",
    borderRadius: "4px",
    border: "1px solid #ccc",
    width: "100%",
    boxSizing: "border-box",
  };

  const buttonContainerStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "12px",
    flexWrap: "wrap",
    marginTop: "20px",
    width: "100%",
    position: "relative",
    zIndex: 10,
  };

  const buttonStyle = (bgColor) => ({
    minWidth: "120px", // ✅ same size everywhere
    height: "42px",
    padding: "0 20px",
    backgroundColor: bgColor,
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
    fontWeight: "bold",
    whiteSpace: "nowrap", // no text break
  });

  const labelStyle = {
    fontWeight: "bold",
    marginBottom: "5px",
  };

  return (
    <Layout>
      <div style={pageContainerStyle}>
        <div style={containerStyle}>
          <div style={headerStyle}>Card Master</div>

          <div style={rowStyle}>
            <div style={columnStyle}>
              <label style={labelStyle}>Date</label>
              <input
                type="date"
                value={entryDate}
                onChange={(e) => setEntryDate(e.target.value)}
                style={inputStyle}
              />
            </div>

            <div style={columnStyle}>
              <label style={labelStyle}>Card Name</label>
              <input
                type="text"
                value={Cardname}
                onChange={(e) => setCardname(allowAlphaNumeric(e.target.value))}
                style={inputStyle}
              />
            </div>

            <div style={columnStyle}>
              <label style={labelStyle}>Card Number</label>
              <input
                type="text"
                value={Cardno}
                onChange={(e) => setCardno(allowNumbers(e.target.value))}
                style={inputStyle}
              />
            </div>

            <div style={columnStyle}>
              <label style={labelStyle}>Account Name</label>
              <Select
                options={accountNameOptions}
                value={
                  accountNameOptions.find((o) => o.value === Accountname) ||
                  null
                }
                onChange={(selected) =>
                  setAccountname(selected ? selected.value : "")
                }
                placeholder="Select Account Name"
                isSearchable
                styles={{
                  control: (base) => ({
                    ...base,
                    minHeight: "42px",
                    borderRadius: "4px",
                    borderColor: "#ccc",
                  }),
                }}
              />
            </div>

            <div style={columnStyle}>
              <label style={labelStyle}>Abbreviation</label>
              <input
                type="text"
                value={Abbreviation}
                onChange={(e) =>
                  setAbbreviation(allowAlphabets(e.target.value))
                }
                style={inputStyle}
              />
            </div>
          </div>
          <div style={buttonContainerStyle}>
            {!isEditMode && (
              <button style={buttonStyle("#4caf50")} onClick={handleSave}>
                Save
              </button>
            )}
            {isEditMode && (
              <button style={buttonStyle("#2e20abff")} onClick={handleUpdate}>
                Update
              </button>
            )}
            <button style={buttonStyle("#ab2025")} onClick={handleExit}>
              Exit
            </button>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default CreditcardMasterDetailsDesign;
